import React, { useRef, useState } from "react";
import PropTypes from "prop-types";

import { Menu, MenuItem } from "widgets/menu";

import styles from "./columnfooter.css";

import DropDownIcon from "./DownArrow.svg";

export function ColumnFooter(props) {
  const { footer } = props;
  const [showMenu, setShowMenu] = useState(false);
  const [activeMenu, setActiveMenu] = useState("Count");
  const menuButton = useRef(null);
  return (
    <div className={styles.columnfooter}>
      {/* <div>I</div> */}
      <div className={`${styles.name} base-600 ellipsis`}>
        {footer && (
          <span
            className="tiny ellipsis"
            style={{ marginInlineEnd: "var(--space-8)" }}
          >
            {activeMenu}
          </span>
        )}
        {footer && <span className="small">{footer[activeMenu]}</span>}
      </div>
      <div className={styles.arrow} />
      {footer && (
        <button
          className={styles.dropdown}
          onFocus={() => setShowMenu(true)}
          onBlur={() => setShowMenu(false)}
          ref={menuButton}
        >
          <DropDownIcon />
          {showMenu && (
            <div className={`${styles.menu} shadow-4dp`}>
              <Menu>
                {Object.keys(footer).map((column) => {
                  return (
                    <MenuItem
                      key={column}
                      onClick={() => {
                        setActiveMenu(column);
                        setTimeout(() => {
                          menuButton.current.blur();
                        }, 0);
                      }}
                    >
                      {column}
                    </MenuItem>
                  );
                })}
              </Menu>
            </div>
          )}
        </button>
      )}
    </div>
  );
}

ColumnFooter.propTypes = {
  column: PropTypes.any,
  footer: PropTypes.any,
  onResize: PropTypes.func
};
